import { IProductPrice } from 'api/product_sdk';
import { OrderSnippet } from './order';
import { PayoutStatus } from './payout';
import { Store } from './store';
import { EPriceType } from 'components/NewProductStepper/ProductBaseForm/constants';
export enum ProductCategory {
  LP = 'LP', // Local product
  GG = 'GG', //
  LS = 'LS', // Loca service
  IH = 'IH',
  PO = 'PO',
  POLP = 'POLP',
  AF = 'AF',
  LINK = 'LINK',
}

export enum EInHomeProductCategory {
  IH_WITH_DATE = 'IH_WITH_DATE',
  IH_WITHOUT_DATE = 'IH_WITHOUT_DATE',
}

export const ProductCategoryMap = {
  [ProductCategory.LP]: 'Local Product',
  [ProductCategory.GG]: 'Grab & Go',
  [ProductCategory.LS]: 'Local Service',
  [ProductCategory.IH]: 'In home',
  [ProductCategory.PO]: 'Preorder Product',
  [ProductCategory.POLP]: 'Preorder Local Product',
  [ProductCategory.AF]: 'Affiliate',
  [ProductCategory.LINK]: 'Link',
};

export enum ProductSubcategory {
  AddOns = 'Add ons',
  Link = 'External link',
  FoodAndBeverage = 'Food and beverage',
  GoodsAndEssentials = 'Goods and essentials',
  GuestServices = 'Guest services',
  LocalServices = 'Local services', // Add a new subcategory only for guest view tab
  Rentals = 'Rentals',
  SomethingElse = 'Something else',
}

export type ServiceType =
  | 'LYFT'
  | 'UBER'
  | 'TURO'
  | 'INSTACART'
  | 'DRIZLY'
  | 'OPENTABLE'
  | 'RESY'
  | 'GRUBHUB'
  | 'CAVIAR';

/**
 * TODO: Once we recover data from BE it is transformed, we should not do this and just camel case keys.
 *    name: 'product_name',
 */
export interface Product {
  id: number;
  image?: string;
  productDelegates?: string[];
  dateCreated?: string;
  dateModified?: string;
  isArchived?: boolean;
  dateArchived?: string;
  name?: string;
  productSku?: string;
  ownerLocalProductCommission?: string;
  ownerLocalProductAmount?: string;
  category?: ProductCategory;
  description: string;
  cancellationPolicy: string;
  instructions?: string;
  price?: string;
  isTaxable?: boolean;
  serviceType?: ServiceType;
  merchantName?: string;
  merchantEmail?: string;
  merchantUrl?: string;
  merchantAmount?: string;
  quantity?: number;
  alertThreshold?: number;
  preorderBy?: number;
  store: Store;
  bundle?: number;
  localProduct?: number;
  merchant?: number;
  isActive?: boolean;
  subcategory?: string;
  hasQuantity?: boolean;
  requiresApproval?: boolean;
  affiliateLink?: string;
  externalLink?: string;
  isUs?: boolean;
  isInternational?: boolean;
  extraFields?: ProductExtraField[];
  productGroup?: number;
  massCreate?: boolean;
  massUpdate?: boolean;
  storeArrangement?: number;
  priceType: EPriceType;
  productPrices?: Array<IProductPrice>;
  storeId?: number;
  showDeliveryDate?: boolean;
  isPurchasableOffPlatform?: boolean;
  instructionsOffPlatform?: string;
  isDefaultPayoutSplit?: boolean;
  amountSplits?: Array<{ recipient: string; amount: number | string }>;
  percentageSplits?: Array<{ recipient: string; percents: number | string }>;
}

export type ProductExtraField = {
  id?: number;
  label: string;
};

export type ProductExtraFieldValue = {
  productField: number;
  label: string;
  value: string;
};

export type InputProduct = Omit<
  Partial<Product>,
  'id' | 'dateCreated' | 'dateModified' | 'dateArchived'
>;

export interface OrderProduct {
  deliveryDate: string;
  id: number;
  merchantAmount: string;
  merchantPayoutStatus: PayoutStatus;
  note?: string;
  order: OrderSnippet;
  price: string;
  productInfo?: Product;
  productName: string;
  quantity: number;
  taxablePrice: string;
  extraFieldValues?: ProductExtraFieldValue[];
}
